import { render, staticRenderFns } from "./OptionPositionCal.vue?vue&type=template&id=0be451fe&lang=pug"
import script from "./OptionPositionCal.vue?vue&type=script&lang=js"
export * from "./OptionPositionCal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports